import DefaultPaletteOptions from 'theming/defaultPalette';

export default (palette: DefaultPaletteOptions): any => ({
  styleOverrides: {
    root: {
      fontSize: '1rem',
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      fontWeight: '400'
    }
  }
});
